export default __webpack_public_path__ + "6fc457ef075a5655241cf219334244c0.png";